import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import PublicProfile from "@/pages/PublicProfile";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AdminPanel from "@/pages/AdminPanel";

function ProtectedBarber({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="theme-dash flex items-center justify-center min-h-screen text-sm text-neutral-500">Yükleniyor…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (isAdmin) return <Navigate to="/admin" replace />;
  return children;
}

function ProtectedAdmin({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="theme-dash flex items-center justify-center min-h-screen text-sm text-neutral-500">Yükleniyor…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route path="/dashboard/*" element={<ProtectedBarber><Dashboard /></ProtectedBarber>} />
          <Route path="/admin/*" element={<ProtectedAdmin><AdminPanel /></ProtectedAdmin>} />
          <Route path="/:slug" element={<PublicProfile />} />
          <Route path="/:slug/h/:code" element={<PublicProfile />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
